import { includes } from 'lodash';
import { CONNECTION_CATEGORY_BUCKET_TYPE_FILES } from 'js/constants/connectionCategories';

type GetFilePath = {
  file: { name: string };
  sourceType: string;
  sourceConfig: {
    path: string;
    bucket?: string;
    allowGrouping: boolean;
    advanced_settings: string;
  };
};

/**
 * @DOC
 * the function constructs and returns the file path by concatenating effectiveBucket, separator, and name.
 */
export function getFilePath({ file, sourceConfig, sourceType }: GetFilePath): string {
  const { name } = file;

  if (!includes(CONNECTION_CATEGORY_BUCKET_TYPE_FILES, sourceType)) return name;

  let path: string | undefined;
  let bucket: string | undefined;
  let effectiveBucket: string | undefined;

  if (sourceConfig) {
    path = sourceConfig.path;
    bucket = sourceConfig.bucket;
  }

  if (path) {
    const slashIndex = path.indexOf('/');
    effectiveBucket = slashIndex > -1 ? path.substring(0, slashIndex) : path;
  } else if (bucket) {
    effectiveBucket = bucket;
  }
  // TODO: not able to replicate effectiveBucket undefined
  const separator =
    (effectiveBucket && effectiveBucket.endsWith('/')) || name.startsWith('/') ? '' : '/';

  return `${effectiveBucket}${separator}${name}`;
}
